export const COLUMN_ACCOUNT_CODE: string = "accountCode";
export const COLUMN_ACCOUNT_NAME: string = "accountName";
export const COLUMN_AGGREGATE_DEAL_ID: string = "aggregateRef";
export const COLUMN_BACK_OFFICE_IDS: string = "bookingIds";
export const COLUMN_BM_FIXING_TIME: string = "reqFixingTime";
export const COLUMN_CLIENT_ALLIN: string = "allInClientRate";
export const COLUMN_CLIENT_BRANCH: string = "clientBranchCode";
export const COLUMN_CLIENT_CODE: string = "clientCode";
export const COLUMN_CLIENT_COMMENT: string = "clientComment";
export const COLUMN_CLIENT_NAME: string = "clientName";
export const COLUMN_CLIENT_PTS: string = "forwardPoints";
export const COLUMN_CLIENT_SPOT: string = "spotClientRate";
export const COLUMN_CHANNEL_CODE: string = "channelCd";
export const COLUMN_CLORDERID: string = "clOrdId";
export const COLUMN_CONFIRMED_BY: string = "confirmedSalesUserId";
export const COLUMN_COUNTER_AMT: string = "amt2";
export const COLUMN_COUNTER_CURRENCY: string = "counterCcy";
export const COLUMN_DEAL_ID: string = "id";
export const COLUMN_DEALT_AMT_USD: string = "usdEquivAmt";
export const COLUMN_DEALT_AMT: string = "amt1";
export const COLUMN_DEALT_CCY: string = "dealtCcy";
export const COLUMN_DEALT_CURRENCY: string = "dealtCcy";
export const COLUMN_DIR: string = "isBuy";
export const COLUMN_ENTRY_DATE: string = "entryDate";
export const COLUMN_ENTRY_USER_ID: string = "entryUserId";
export const COLUMN_EXTERNAL_PRIMARY_EXEC_ID: string = "makerDealRef";
export const COLUMN_EXTERNAL_SECONDARY_EXEC_ID: string = "secondaryMakerDealRef";
export const COLUMN_FILL_COMMENT: string = "fillComment";
export const COLUMN_FILL_DATE: string = "creationDate";
export const COLUMN_FILL_STATE: string = "fillState";
export const COLUMN_FILL_USER_CODE: string = "fillUserCode";
export const COLUMN_FILL_USER_NAME: string = "fillUserName";
export const COLUMN_FIXING_DATE: string = "fixingDate";
export const COLUMN_FWD_PORTFOLIO: string = "fwdNettingId";
export const COLUMN_LAST_MARKET: string = "lastMkt";
export const COLUMN_MARKET_ALLIN: string = "forwardMarketRate";
export const COLUMN_MARKET_PTS: string = "forwardMarketPoints";
export const COLUMN_MARKET_SPOT: string = "spotMarketRate";
export const COLUMN_MARKUP: string = "salesMargin";
export const COLUMN_OBO_ACCOUNT: string = "oboAccount";
export const COLUMN_OBO_CLIENT: string = "oboClient";
export const COLUMN_OBO_ENTRY_USER: string = "oboEntryUser";
export const COLUMN_ORDER_ID: string = "orderId";
export const COLUMN_ORDER_PASS_THROUGH_PARAMETERS: string = "passthroughParameters";
export const COLUMN_ORDER_TYPE: string = "requestOrderType";
export const COLUMN_PRIVATE_COMMENT: string = "privateComment";
export const COLUMN_REQUEST_RATE: string = "requestedPx";
export const COLUMN_SPOT_PORTFOLIO: string = "nettingId";
export const COLUMN_STRATEGY_ID: string = "strategyId";
export const COLUMN_TRADE_CLIENT_TRADER: string = "clientTraderName";
export const COLUMN_TRADE_DATE: string = "tradeDate";
export const COLUMN_TRADE_DESK_ID: string = "traderGroupId";
export const COLUMN_TRADE_FIXING_SOURCE_CODE: string = "fixingCode";
export const COLUMN_TRADE_INSTRUMENT: string = "productId";
export const COLUMN_TRADE_ORDER_PRODUCT: string = "productType";
export const COLUMN_TRADE_ORDER_TYPE: string = "requestOrderType";
export const COLUMN_TRADE_SALES_GROUP_ID: string = "salesGroupId";
export const COLUMN_TRADE_VALUE_DATE: string = "valueDate";
export const COLUMN_TRADER_GROUP_ID: string = "traderGroupId";

// Column Ids that don't match DealImpl fields
export const COLUMN_BM_FIXING_TIME_UTC: string = "fixingTimeUTC";
export const COLUMN_DEAL_STATE: string = "dealState";
export const COLUMN_INSTRUMENT: string = "instrument";
